import Image from "next/image";
import Link from "next/link";
import { FaSearchengin, FaStar } from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { BaseModalDialog } from "@/components/modals/base-modal-dialog";

export interface ProductImageData {
  image_url: string;
}

export interface ProductUnitData {
  price: number;
  discount_price: number;
  base_price: number;
}

export interface ProductData {
  description: string;
  id: string;
  main_picture_url: string | null;
  name: string;
  ProductImages: ProductImageData[];
  ProductUnits: ProductUnitData[];
  metadata: ProductMetadataInterface;
  main_price: number;
  nonpromo_price: number;
  rating_number: number;
  total_sold_number: string;
  save: number;
  save_percentage: number;
}

export interface ProductMetadataCompetitorComparison {
  store_name?: string;
  link?: string;
  price?: number;
  thumbnail?: string;
  checked_date?: string;
  is_delivery_price_included?: boolean;
  rating_number?: number;
  total_sold_number?: number;
  total_view_number?: number;
}

export interface ProductMetadataInterface {
  nonpromo_price?: number;
  min_qty?: number;
  rating_number?: number;
  total_sold_number?: number;
  total_view_number?: number;
  is_promo?: boolean;
  promo_deadline_date?: string;
  competitor_comparison?: ProductMetadataCompetitorComparison[];
}

export type ProductCollectionData = {
  id: string;
  title: string;
  featured: boolean;
  order: number;
  background_image: string;
  product_ids: string[];
  products: ProductData[];
}

const IdrCurrency = (number) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(number);
};

export function HomeCatalogSection({ collections }: {
  collections: ProductCollectionData[];
}) {
  // const [selectedCollection, selectCollection] = useState<CollectionData | null>((collections ?? []).length > 0 ? (collections ?? [])[0] : null);
  const selectedCollection = (collections ?? []).length > 0 ? (collections ?? [])[0] : null;
  const [selectedProduct, setProduct] = useState<ProductData | null>(null);
  const [isComparisonSheetOpen, showComparisonSheet] = useState<boolean>(false);

  return (
    <section className="max-w-screen-xl w-full relative pt-12 pb-8">
      <div className="flex flex-col items-center w-full">
        <div className="hidden sm:flex flex-col text-center">
          <h1 className="text-black font-bold text-3xl">
            Penuhi Kebutuhan Jualan Juragan Dengan Berbagai 
          </h1>
          <h1 className="text-black font-bold text-3xl">
            Produk Multi Kategori Kami, Harga Grosir Termurah!
          </h1>
        </div>
        <div className="block sm:hidden text-center px-4">
          <h1 className="text-black font-bold text-xl">
            Penuhi Kebutuhan Jualan Juragan Dengan Berbagai Produk Multi Kategori Kami, Harga Grosir Termurah!
          </h1>
        </div>
        {/* {collections.length > 1 && (
              <div>
              </div>
            )} */}
        <div className="w-full min-h-[583px] relative flex flex-col xl:rounded-2xl overflow-hidden drop-shadow-lg mt-8 cursor-pointer">
          <div className="absolute inset-y-0 w-max h-full">
            <Image src="/img/jooalan/collection-bg.png" height={480} width={1280} alt="collection background" className="object-center" />
          </div>
          <div className="absolute h-3/4 inset-x-0 bottom-0 z-1" style={{ background: 'linear-gradient(0deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0) 100%)' }} />
          <div className="absolute inset-x-0 bottom-0 w-full flex flex-col items-center z-10">
            <div className="flex flex-row gap-4 mb-12 w-full max-w-max overflow-x-scroll px-8 pb-2" style={{
              scrollbarWidth: 'none'
            }}>
              {selectedCollection && selectedCollection.products.map((p) => (
                <div key={p.id} className="bg-white rounded-md ring-1 ring-gray-200 shadow-light w-52 overflow-hidden relative shrink-0">
                  <div className="size-52">
                    <object data={p.main_picture_url} type="image/jpg" className="size-full">
                      <img src={`url(/img/shopping-bag.jpg)`} alt="" />
                    </object>
                  </div>
                  <div className="mt-2 px-2">
                    <div className="text-base">{p.name}</div>
                    <div className="relative">
                      <div className="text-sm line-through text-red-500 font-bold mt-1">{IdrCurrency(p.nonpromo_price)}</div>
                    </div>
                    <div className="relative">
                      <div className="text-lg font-bold">{IdrCurrency(p.main_price)} <span className="text-sm">/ Pcs</span></div>
                    </div>
                    <div className="flex items-center text-green-600 text-xs font-medium">
                      <FiArrowUpRight className="size-5 mr-1" />
                      <span>
                        Margin keuntungan <br /> {IdrCurrency(p.save)} ({p.save_percentage}%)
                      </span>
                    </div>
                    <div className="flex flex-row items-centerpl-2 pb-1 mt-3">
                      <FaStar className="text-yellow-600" />
                      <div className="text-xs ml-1 text-gray-400">{p.rating_number} | {p.total_sold_number} terjual</div>
                    </div>
                  </div>
                  <div className="">
                    {(p.metadata?.competitor_comparison ?? []).length > 0 && (
                      <div className="px-2 pb-2 mt-2">
                        <Button variant="outline" className="w-full border-2 border-primary gap-2" onClick={() => {
                          setProduct(p);
                          showComparisonSheet(true);
                        }}>
                          <FaSearchengin className="size-4 text-primary" />
                          <div className="text-primary font-semibold">Bandingkan Harga</div>
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-row justify-center z-10 mb-8">
              <Link href="/join">
                <div className=" bg-[#F9B920] max-w-max font-bold px-4 py-2 rounded-3xl hover:bg-accent cursor-pointer animate-bounce">
                  Lihat semua produk
                </div>
              </Link>
            </div>
          </div>
        </div>
        <BaseModalDialog
          isOpen={isComparisonSheetOpen}
          onClose={() => { showComparisonSheet(false) }}
          shouldCloseOnOverlayClick={true}
          className="w-full"
        >
          <div className="flex flex-col gap-4 mt-4">
            {(selectedProduct?.metadata?.competitor_comparison ?? []).map((p => (
              <div key={p.store_name} className="border rounded-md">
                <div className="relative w-full h-auto aspect-[16/9] overflow-hidden rounded-lg bg-gray-100 flex flex-col justify-center">
                  {p.thumbnail && (
                    <object data={p.thumbnail} type="image/jpg" className="h-auto w-full">
                      <img src={`url(/img/shopping-bag.jpg)`} className="h-auto w-full object-contain" alt="" />
                    </object>
                  )}
                  {!p.thumbnail && (
                    <img src={`url(/img/shopping-bag.jpg)`} className="h-auto w-full object-contain" alt="" />
                  )}
                </div>
                <div className="px-3 mt-3 pb-3">
                  <div className="font-semibold">{p.store_name}</div>
                  <div className="text-red-500 font-bold text-2xl">{IdrCurrency(p.price ?? 0)}</div>
                  <div className="text-red-500">+{IdrCurrency((p.price ?? 0) - selectedProduct.main_price)} lebih mahal</div>
                  {/*
                <div className="flex flex-row gap-1 mt-2">
                  <Icon icon="ion:star" className="size-4 text-yellow-400" />
                  <span className="text-sm text-gray-500">{(p.rating_number ?? 0).toFixed(1)}</span>
                  <span className="text-sm text-gray-500">|</span>
                  <span className="text-sm text-gray-500"><NumberFormatDisplay value={p.total_sold_number ?? 0} /> terjual</span>
                  {((p.total_view_number ?? 0) > 0) && <span className="text-sm text-gray-500">|</span>}
                  {((p.total_view_number ?? 0) > 0) && <span className="text-sm text-gray-500"><NumberFormatDisplay value={p.total_view_number ?? 0} /> dilihat</span>}
                </div>
                <div className="text-xs mt-1">Dicek pada: {dayjs(p.checked_date ?? new Date()).format('DD-MM-YY')}</div>
                */}
                </div>
              </div>
            )))}
          </div>
        </BaseModalDialog>
      </div>
    </section>
  )
}